import { Typography } from 'antd';
import { map } from 'lodash';
import React, { useMemo, useState } from 'react';

const { Paragraph } = Typography;
const EllipsisText = ({ text, className, onClick, heightRows = 4 }) => {
  const [ellipsis, setEllipsis] = useState(true);
  return useMemo(() => {
    return (
      <div key={`${Math.random()}`} className={className}>
        <Paragraph
          className={`expand-text ${className}`}
          ellipsis={
            ellipsis
              ? {
                  rows: heightRows,
                  symbol: 'View More',
                  expandable: true,
                  onExpand: (e) => {
                    e.stopPropagation();
                    setEllipsis(false);
                  },
                }
              : false
          }
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          {map(text?.split('\n'), (val, index) => {
            return (
              <React.Fragment key={index}>
                {val}
                {text?.split('\n')?.length - 1 > index && <br />}
              </React.Fragment>
            );
          })}
        </Paragraph>

        {!ellipsis && (
          <div
            className="text-primary pointer"
            onClick={(e) => {
              e.stopPropagation();
              setEllipsis(true);
            }}
          >
            View Less
          </div>
        )}
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, ellipsis]);
};
export default EllipsisText;
